// Iter 604 — Konfirmasi shift saat progres dicatat di luar jadwal (tidak pernah memblokir penyimpanan).
import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function Dialog({ r, done }) {
  const [pick, setPick] = useState(0);
  const [reason, setReason] = useState("");
  const o = r.options;
  return <div className="modal-overlay" data-testid="shift-confirm-modal">
    <div className="modal" style={{ maxWidth: 380 }}>
      <h3 style={{ marginTop: 0 }}>Konfirmasi shift hasil kerja</h3>
      <p className="muted small" style={{ margin: "4px 0 10px" }}>Dicatat di luar jadwal Anda. Pilih shift & tanggal kerja hasil ini — penyimpanan tetap diperbolehkan.</p>
      {o.map((x, i) => <label key={`${x.shift}-${x.work_date}`} style={{ display: "flex", gap: 8, alignItems: "center", padding: "8px 0", fontSize: 15 }}>
        <input type="radio" name="shift-pick" checked={pick === i} onChange={() => setPick(i)} data-testid={`shift-confirm-option-${i}`}/>
        <span>{x.label}{i === 0 ? " (disarankan)" : ""}</span>
      </label>)}
      <input value={reason} onChange={e => setReason(e.target.value)} placeholder="Alasan (opsional), mis. lembur" maxLength={200}
        data-testid="shift-confirm-reason" style={{ width: "100%", padding: 8, margin: "6px 0 12px", boxSizing: "border-box" }}/>
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <button type="button" className="soft-btn" onClick={() => done(null)} data-testid="shift-confirm-cancel">Batal</button>
        <button type="button" className="primary" onClick={() => done({ shift: o[pick].shift, work_date: o[pick].work_date, reason })} data-testid="shift-confirm-save">Simpan</button>
      </div>
    </div>
  </div>;
}

// Kembalikan shift_choice (atau undefined bila tidak perlu). Lempar Error bila operator membatalkan.
export async function confirmShift() {
  let r;
  try { r = (await axios.get(`${API}/bordir-tasks/shift-resolve`, { withCredentials: true, timeout: 8000 })).data; }
  catch { return undefined; }
  if (!r?.needs_confirm) return undefined;
  const el = document.createElement("div");
  document.body.appendChild(el);
  const root = createRoot(el);
  const choice = await new Promise(res => root.render(<Dialog r={r} done={res}/>));
  root.unmount();
  el.remove();
  if (!choice) throw new Error("Penyimpanan dibatalkan");
  return choice;
}
